import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ClientHeader } from "./ClientShell";
import { capi, useNoindex } from "./clientApi";
import CampaignDashboardView from "./CampaignDashboardView";

export default function ClientCampaign() {
  useNoindex();
  const navigate = useNavigate();
  const { id } = useParams();
  const [me, setMe] = useState(null);
  const [data, setData] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    let alive = true;
    (async () => {
      const meRes = await capi("/me").catch(() => null);
      if (!meRes || meRes.status === 401) { navigate("/espace-client/connexion"); return; }
      const meData = await meRes.json();
      const res = await capi(`/campaigns/${id}/dashboard`).catch(() => null);
      if (!alive) return;
      setMe(meData);
      if (!res || !res.ok) { setState("notfound"); return; }
      setData(await res.json());
      setState("ok");
    })();
    return () => { alive = false; };
  }, [id, navigate]);

  const logout = async () => { await capi("/auth/logout", { method: "POST" }).catch(() => {}); navigate("/espace-client/connexion"); };

  return (
    <div className="cp-root" data-testid="cp-campaign-page">
      <ClientHeader me={me} onLogout={logout} hasNews />
      <div className="cp-page">
        {state === "loading" && <p className="cp-muted" data-testid="cp-campaign-loading">Chargement…</p>}
        {state === "notfound" && (
          <>
            <button className="cp-back" onClick={() => navigate("/espace-client")} data-testid="cp-back">← Mes campagnes</button>
            <div className="cp-panel" data-testid="cp-campaign-notfound">Campagne introuvable</div>
          </>
        )}
        {state === "ok" && <CampaignDashboardView data={data} />}
      </div>
    </div>
  );
}
